import React from 'react';
import { render } from 'react-dom';

import { DEFAULT_CRITICAL_BACKUP_CURRENCY } from '../../util/currency';
import { getErrorMessageKey } from '../../util/errorCodes';
import jsonGet from '../../util/jsonGet';

import { STORAGE_KEYS, getLocalStorage } from '../../util/storage';
import BookingPayment from '../react/BookingPayment';
import ErrorMessage from '../react/Core/ErrorMessage';
import Loading from '../react/Core/Loading';
import CUSTOM_EVENT from '../../util/customEvents';

export default class MakePaymentPaymentRender {
  constructor(context) {
    this.context = context;
    this.init();

    this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
    // clean up is within index.jsx of MakePaymentPayment
    window.addEventListener(CUSTOM_EVENT.CURRENCY_CHANGE, this.handleCurrencyChange);
  }

  cleanup() {
    window.removeEventListener(CUSTOM_EVENT.CURRENCY_CHANGE, this.handleCurrencyChange);
  }

  fetchData(loadApiUrl, currentCurrencyCodeAndSymbol, labels, submitApiUrl) {
    const { code: currencyCode, symbol: currencySymbol } = currentCurrencyCodeAndSymbol;
    const payload = { currency: currencyCode };

    jsonGet(loadApiUrl, payload, (response) => {
      if (response.errorCode) {
        const errorMessageKey = getErrorMessageKey(response.errorCode);
        return render(
          <ErrorMessage text={labels[errorMessageKey] || response.message} />,
          this.context
        );
      }

      return render(
        MakePaymentPaymentRender.renderMain(response, labels, submitApiUrl, currencySymbol),
        this.context
      );
    });
    return render(
      MakePaymentPaymentRender.renderMain(undefined, labels, submitApiUrl, currencySymbol),
      this.context
    );
  }

  init(currentCurrency = null) {
    const { apiUrl, model, loadApi } = this.context.dataset;
    if (!apiUrl || !model || !loadApi) throw Error('Missing a required dataset');

    let labels;
    try {
      labels = JSON.parse(model);
    } catch (e) {
      labels = undefined;
      console.error('Error parsing labels json: ', model);
    }

    const currentCurrencyCodeAndSymbol =
      currentCurrency ||
      getLocalStorage(STORAGE_KEYS.currentCurrency, DEFAULT_CRITICAL_BACKUP_CURRENCY);

    this.fetchData(loadApi, currentCurrencyCodeAndSymbol, labels, apiUrl);
  }

  handleCurrencyChange(event) {
    const newCurrencyCodeAndSymbol = event?.detail;
    if (newCurrencyCodeAndSymbol) {
      this.init(newCurrencyCodeAndSymbol);
    }
  }

  static renderMain(data, labels, apiUrl, currencySymbol) {
    return data ? (
      <BookingPayment
        data={data}
        labels={labels}
        submitUrl={apiUrl}
        currencySymbol={currencySymbol}
        cleanup={this.cleanup}
      />
    ) : (
      <Loading />
    );
  }
}
